import { ReactComponent } from "./expand-less.svg";

const ExpandLessIcon = () => <ReactComponent />;

export default ExpandLessIcon;
